








import Vue from 'vue';
import logo from '../../assets/logo.png';

/**
 * Stratum Five loading animation
 */
export default Vue.extend({
  name: 'SLoadingAnim',
  data(): any {
    return { logo };
  },
});
